const $ = window.jQuery;

module.exports = function($container) {
  let ajaxCount = 0;

  const updateContainerClass = function() {
    if (ajaxCount > 0) {
      $container.addClass('ajax');
    } else {
      $container.removeClass('ajax');
    }
  };

  $.ajaxSetup({
    // timeout: 5000,
    // headers: { 'X-Requested-With': 'XMLHttpRequest' },
    beforeSend() {
      ajaxCount++;
      updateContainerClass();
    },
    complete() {
      ajaxCount--;
      updateContainerClass();
    }
  });
};



// WEBPACK FOOTER //
// ./src/ajax.js